import { buildScheduleEventCommunicationTagPresentation } from "../../../../../../../../../../../_shared/_logic/communication-presentation"
import { buildAppointmentTimeTagPresentation } from "../../../../../../../../../../../_shared/_logic/appointment-time-tags"
import { displayContactOrderStatusLabel } from "../../../../../../../../../../../_shared/_logic/outreach-presentation"
import {
  buildRichTooltip,
  tooltipField,
} from "../../../../../../../../../../../_shared/_logic/rich-tooltips"
import type { BoardEvent } from "../../../../../../../../_logic/calendar-types"

type BoardPropertyRef = NonNullable<BoardEvent["property"]>

const contactOrderStatusLabels: Partial<Record<string, string>> = {
  PLANNED: "Geplant",
  ACTIVE: "Aktiv",
  CLOSED: "Geschlossen",
}

export const buildEventTooltip = ({
  item,
  includeAppointmentCommunication = true,
}: {
  item: BoardEvent
  includeAppointmentCommunication?: boolean
  employeeLabel?: string
  formatAddress: (property?: BoardPropertyRef) => string
}) => {
  const planningFlag = item.planningFlag ?? item.event.planning_flag
  const planningFlagLabel =
    item.planningFlagLabel ??
    (planningFlag === "TIGHT" ? "Eng" : planningFlag === "OVERFLOW" ? "Überlauf" : "")
  const communication =
    includeAppointmentCommunication && item.event.event_type === "APPOINTMENT"
      ? buildScheduleEventCommunicationTagPresentation({
          status: item.event.status,
          event: item.event,
        })
      : null
  const time = buildAppointmentTimeTagPresentation(item.event, { mode: "calendar" })

  return (
    (communication?.tooltip ?? "") +
    buildRichTooltip([
      tooltipField("Adresse", item.addressLabel),
      tooltipField("Kalenderzeit", time.scheduledPeriodLabel),
      time.isFlex ? tooltipField("Zeitfenster", time.timeWindowLabel) : null,
      tooltipField("Kundenhinweis", item.event.customer_note),
      planningFlagLabel ? tooltipField("Planung", planningFlagLabel) : null,
    ])
  )
}

export const resolveContactOrderStatusLabel = (status?: ContactOrder["status"] | null) =>
  status ? (contactOrderStatusLabels[status] ?? displayContactOrderStatusLabel(status)) : ""
